import { render } from "./IraInformation.vue?vue&type=template&id=03643e71"
import script from "./IraInformation.vue?vue&type=script&lang=js"
export * from "./IraInformation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__